import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pyramid-maya"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 9V3H8V9H16Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M6 12V9H10V22H3V18H4V15H5V12H6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M18 12V9H14V22H21V18H20V15H19V12H18Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 5.99805H12.0039V6.00195H12V5.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 3V9M16 3H8M16 3H17M8 3V9M8 3H7M16 9H18V12H19V15H20V18H21V22H14M16 9C15.1506 9 14 9 14 9M8 9H6V12H5V15H4V18H3V22H10M8 9C8.81054 9 10 9 10 9M10 9H14M10 9V12V15V18V22M10 22H14M14 22V18V15V12V9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PyramidMaya = Vue.extend<IconProps>({
  name: 'PyramidMayaIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pyramid-maya',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PyramidMaya;
